/*
  SylverCar — Bilan confort & équipement : liaison avec Omnisend.

  CE QUE LE NAVIGATEUR PEUT FAIRE, SANS CLÉ PRIVÉE (vérifié le 13/10/2026) :
    - identifier un contact par son e-mail (omnisend.identifyContact) ;
    - envoyer un événement personnalisé avec ses propriétés (omnisend.push track).
  CE QU'IL NE PEUT PAS FAIRE : poser un consentement marketing, ni écrire des
  propriétés sur la fiche du contact. Ces deux actions exigent la clé privée de
  l'API, qui ne doit jamais apparaître dans le navigateur.

  D'OÙ CES CHOIX
    - CONSENTEMENT (S5 = « Oui ») : le visiteur est inscrit à la lettre de la
      boutique par le formulaire client de Shopify (le même que celui du pied de
      page : étiquette « newsletter »). Omnisend est connecté à la boutique et en
      reprend le contact et son consentement. Rien n'est inscrit si S5 = « Non ».
    - DONNÉES DE SEGMENTATION : elles voyagent comme PROPRIÉTÉS DE L'ÉVÉNEMENT
      « quiz completed » (quiz_besoin, quiz_sortie, quiz_zone, …). Omnisend sait
      segmenter et déclencher des flows sur les propriétés d'un événement. Le
      nombre de bilans et leurs dates se déduisent du nombre d'événements.
    - L'événement part de la PAGE DE RÉSULTAT et non du quiz : c'est elle qui
      connaît les produits affichés (titre, prix, image, lien) dont l'e-mail du
      bilan a besoin. Le quiz laisse la charge dans sessionStorage ; la page de
      résultat l'envoie une seule fois.

  Aucune adresse e-mail n'est jamais placée dans un événement : elle sert à
  identifier le contact, pas à décrire l'événement.
  Rien ne bloque le visiteur : tout échec est mis en file et retenté plus tard.
*/
(function () {
  'use strict';

  /* Identifiant de la boutique chez Omnisend (celui que la page envoie deja dans l'URL d'identification). Sans lui, un
     evenement envoye AVANT que le script ait fini de charger ses reglages part sans brandID : Omnisend repond 400
     (constate sur le test reel du 15/10/2026, a la page de resultat). */
  var BRAND_ID = '67dd6bd1aae9d7bc6fdbdcf2';
  var CLE_FILE = 'sc_bilan_file';
  var CLE_A_ENVOYER = 'sc_bilan_a_envoyer';

  function lire(cle, stock) { try { return JSON.parse((stock || localStorage).getItem(cle)); } catch (e) { return null; } }
  function ecrire(cle, val, stock) { try { (stock || localStorage).setItem(cle, JSON.stringify(val)); } catch (e) { } }
  function effacer(cle, stock) { try { (stock || localStorage).removeItem(cle); } catch (e) { } }

  /* MODE RECETTE. Dans l'aperçu d'un thème non publié, Shopify.theme.role vaut « unpublished » ; il vaut « main »
     sur le thème en ligne. Tant que le thème n'est pas publié, RIEN n'est envoyé à Omnisend ni à Shopify : ni
     identification, ni inscription, ni événement. L'écran reste identique, pour une recette fidèle, et le mode
     s'éteint tout seul à la publication. (?recette=1 le force, par exemple pour une démonstration sur le thème
     en ligne ; rien ne permet de l'éteindre par l'adresse.) */
  function enRecette() {
    try {
      if (/(?:^|[?&])recette=1(?:&|$)/.test(location.search)) return true;
      var t = window.Shopify && window.Shopify.theme;
      return !!(t && t.role && t.role !== 'main');
    } catch (e) { return false; }
  }
  function silence(quoi) { try { console.info('[bilan] mode recette : ' + quoi + ' — rien n\'est envoyé.'); } catch (e) { } }

  function omni() { window.omnisend = window.omnisend || []; return window.omnisend; }

  function identifier(email) {
    if (!email) return;
    try {
      var o = omni();
      if (typeof o.identifyContact === 'function') o.identifyContact({ email: email });
      else o.push(['identifyContact', { email: email }]);
    } catch (e) { /* l'identification est un plus */ }
  }

  /* Événement personnalisé :
       omnisend.push(["track", nom, { origin: "api", eventID, eventVersion: "", contact: { email }, properties: {...} }])
     LE CHAMP « contact » EST INDISPENSABLE. Le script d'Omnisend (launcher-v2.js) n'envoie l'événement que s'il
     connait le contact : par ce champ ou par le cookie omnisendContactID. Ce cookie n'est posé qu'après la réponse
     de l'identification, donc jamais à temps sur la page de résultat ; sans « contact », l'appel part dans le vide,
     sans requête ni erreur (constaté sur le test réel du 15/10/2026).
     Les propriétés sont TOUTES des chaînes (une chaîne est acceptée partout et suffit aux filtres du flow :
     « true », « oui », « confort »).
     Le script ne rappelle JAMAIS les fonctions onSuccess/onError : aucune confirmation n'existe. Il refait lui-même
     3 essais en cas d'échec réseau ; rejouer ici risquerait de déclencher DEUX fois l'e-mail. La promesse vaut donc
     true dès que l'appel a été remis au script avec un contact, false sans adresse (rien n'a pu partir). */
  function evenement(nom, proprietes, identifiant, email) {
    return new Promise(function (resoudre) {
      try {
        var props = {};
        Object.keys(proprietes || {}).forEach(function (k) {
          var v = proprietes[k];
          if (v === undefined || v === null) return;
          props[k] = String(v);
        });
        var charge = { origin: 'api', eventID: identifiant || identifiantEvenement(), eventVersion: '', properties: props, brandID: BRAND_ID };
        if (email) charge.contact = { email: email };
        omni().push(['track', nom, charge]);
        resoudre(!!email);
      } catch (e) { resoudre(false); }
    });
  }

  /* Adresse déjà donnée au quiz (mémoire locale ou de session) : sert aux événements envoyés sans passer par le quiz. */
  function emailConnu() {
    try {
      var id = lire('sc_bilan_id');
      if (id && id.email) return id.email;
      var env = lire('sc_bilan_envoye', sessionStorage);
      if (env && env.email) return env.email;
    } catch (e) { }
    return '';
  }

  /* Inscription à la lettre par le formulaire client de Shopify (formulaire masqué, #bq-abonnement). */
  function abonner(email) {
    var f = document.getElementById('bq-abonnement');
    if (!f || !email) return Promise.resolve(false);
    var donnees = new URLSearchParams(new FormData(f));
    donnees.set('contact[email]', email);
    return fetch(f.getAttribute('action') || '/contact', {
      method: 'POST', body: donnees.toString(), credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(function (r) {
      // Réussite : Shopify revient avec customer_posted=true. Un défi anti-robot (/challenge) n'est pas un succès.
      return /customer_posted=true/.test(r.url) || (r.ok && !/challenge/.test(r.url));
    }).catch(function () { return false; });
  }

  function absolu(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return location.origin + u;
    return u;
  }

  /* Produits pour l'e-mail : à plat (produit_1_titre, produit_1_prix, …), 8 au plus. */
  function aplatirProduits(produits) {
    var o = {};
    (produits || []).slice(0, 8).forEach(function (p, i) {
      var n = i + 1;
      o['produit_' + n + '_titre'] = p.titre || '';
      o['produit_' + n + '_prix'] = p.prix || '';
      o['produit_' + n + '_url'] = absolu(p.url);
      o['produit_' + n + '_image'] = absolu(p.image);
    });
    o.produits_nombre = Math.min(8, (produits || []).length);
    return o;
  }

  /* Un événement envoyé mais non confirmé a pu arriver quand même : le rejouer sans limite risquerait de
     déclencher DEUX FOIS l'e-mail du bilan. Il n'est donc repris qu'UNE fois ; l'abonnement, lui, est retenté
     (le formulaire client de Shopify ne crée pas de doublon). */
  function mettreEnFile(element) {
    var f = lire(CLE_FILE) || [];
    element.tentatives = (element.tentatives || 0) + 1;
    f.push(element); ecrire(CLE_FILE, f.slice(-5));
  }
  function identifiantEvenement() {
    try { return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2); }
    catch (e) { return String(Date.now()) + Math.random().toString(16).slice(2); }
  }

  var api = {
    /* Au quiz (S6) : identification, consentement, puis charge laissée à la page de résultat. */
    envoyer: function (charge) {
      if (!charge) return Promise.resolve();
      if (enRecette()) { silence('identification et inscription'); return Promise.resolve(); }
      identifier(charge.email);
      var etapes = [];
      if (charge.email && charge.optin === 'oui' && charge.nouveau !== false) etapes.push(abonner(charge.email));
      ecrire(CLE_A_ENVOYER, charge, sessionStorage);
      return Promise.all(etapes).then(function (r) {
        if (r.length && r[0] === false) mettreEnFile({ type: 'abonnement', email: charge.email });
      });
    },

    /* À la page de résultat, une seule fois par bilan : l'événement avec les produits. */
    bilanTermine: function (infos) {
      if (enRecette()) { silence('événement « quiz completed »'); return Promise.resolve(false); }
      var charge = lire(CLE_A_ENVOYER, sessionStorage);
      if (!charge) return Promise.resolve(false);
      if (charge.sortie && infos.sortie && charge.sortie !== infos.sortie) return Promise.resolve(false);
      effacer(CLE_A_ENVOYER, sessionStorage);
      identifier(charge.email);
      var p = {};
      Object.keys(charge.proprietes || {}).forEach(function (k) { p[k] = charge.proprietes[k]; });
      p.quiz_event_id = identifiantEvenement();
      p.quiz_run_index = charge.run || 1;
      p.quiz_premier_bilan = !!charge.premier;
      p.quiz_optin = charge.optin || '';
      p.quiz_date = charge.date;
      p.quiz_nombre_produits = (infos.produits || []).length;
      p.quiz_phrase = charge.phrase || '';
      p.quiz_url_resultat = absolu(infos.url || charge.url);
      var tout = Object.assign(p, aplatirProduits(infos.produits));
      return evenement('quiz completed', tout, null, charge.email).then(function (ok) {
        if (!ok) mettreEnFile({ type: 'evenement', nom: 'quiz completed', proprietes: tout, email: charge.email });
        return ok;
      });
    },

    /* « Recevoir cette sélection par e-mail » : message de service, sans code ni offre. */
    recevoirBilan: function (infos) {
      if (enRecette()) { silence('événement « quiz selection requested »'); return Promise.resolve(true); }
      var p = {
        quiz_sortie: infos.sortie, quiz_phrase: infos.phrase || '', quiz_source: infos.source || '', quiz_date: infos.date,
        quiz_url_resultat: absolu(infos.url), quiz_nombre_produits: (infos.produits || []).length
      };
      var tout = Object.assign(p, aplatirProduits(infos.produits));
      return evenement('quiz selection requested', tout, null, emailConnu()).then(function (ok) {
        if (!ok) { mettreEnFile({ type: 'evenement', nom: 'quiz selection requested', proprietes: tout }); throw new Error('non confirmé'); }
        return true;
      });
    },

    /* Reprend ce qui n'a pas pu partir (appelée à chaque page de résultat). */
    rejouer: function () {
      if (enRecette()) return Promise.resolve();
      var file = lire(CLE_FILE);
      if (!file || !file.length) return Promise.resolve();
      effacer(CLE_FILE);
      return file.reduce(function (chaine, el) {
        return chaine.then(function () {
          if (el.type === 'abonnement') return abonner(el.email).then(function (ok) { if (!ok) mettreEnFile(el); });
          if ((el.tentatives || 0) >= 2) return null; // abandon : jamais de doublon d'e-mail
          identifier(el.email);
          return evenement(el.nom, el.proprietes, null, el.email || emailConnu()).then(function (ok) { if (!ok) mettreEnFile(el); });
        });
      }, Promise.resolve());
    }
  };

  api.recette = enRecette;
  window.ScBilanOmnisend = api;
})();
